import Link from 'umg-ember-backend/components/record-explorer/for/link';

<template><Link @records={{@model}} @recordType='link' /></template>
